import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Bar,
  ResponsiveContainer,
  ReferenceLine,
  ComposedChart,
  Tooltip
} from 'recharts';

const defaultProps = {
  config: {
    bars: [],
    avgColor: '#FF9800'
  }
};

export default class BarChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      point: null,
      tooltipStyle: {}
    };

    this.onChartMouseMove = this.onChartMouseMove.bind(this);
    this.onChartMouseLeave = this.onChartMouseLeave.bind(this);
  }

  onChartMouseMove(chart) {
    const point = chart.activeCoordinate;

    if (point !== this.state.point) {
      this.setState({
        point
      });
      this.updateTooltip();
    }
  }

  onChartMouseLeave() {
    this.setState({
      point: null
    });
    this.updateTooltip();
  }

  updateTooltip() {
    const { point } = this.state;

    if (point) {
      const x = Math.round(point.x);
      const y = Math.round(point.y);

      this.setState({
        tooltipStyle: {
          left: `${x}px`,
          top: `${y}px`
        }
      });
    } else {
      this.setState({
        tooltipStyle: {}
      });
    }
  }

  render() {
    const { data, config = defaultProps.config } = this.props;
    const { bars = [], referenceLines = [], CustomTooltip } = config;
    const Bars = bars.map((barConfig, idx) => (
      <Bar
        {...{
          dataKey: 'value',
          ...barConfig
        }}
        key={idx.toString()}
      >
        {config.barFn ? config.barFn(data, barConfig) : null}
      </Bar>
    ));

    const ReferenceLines = referenceLines.map((referenceLineConfig, idx) => (
      <ReferenceLine key={`ref_${idx.toString()}`} {...referenceLineConfig} />
    ));

    return (
      <ResponsiveContainer>
        <ComposedChart
          data={data}
          onMouseMove={this.onChartMouseMove}
          onMouseLeave={this.onChartMouseLeave}
        >
          {Bars}
          {ReferenceLines}
          {CustomTooltip ? (
            <Tooltip
              wrapperStyle={{
                ...this.state.tooltipStyle,
                ...{ zIndex: 1 }
              }}
              content={<CustomTooltip />}
            />
          ) : null}
        </ComposedChart>
      </ResponsiveContainer>
    );
  }
}

BarChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      isSelected: PropTypes.bool
    })
  ).isRequired,
  config: PropTypes.shape({
    bars: PropTypes.arrayOf(
      PropTypes.shape({
        dataKey: PropTypes.string
      })
    ),
    avgColor: PropTypes.string,
    referenceLines: PropTypes.arrayOf(
      PropTypes.shape({
        y: PropTypes.number,
        label: PropTypes.shape({
          position: PropTypes.string,
          value: PropTypes.string,
          fill: PropTypes.string,
          fontSize: PropTypes.number
        }),
        stroke: PropTypes.string,
        strokeDasharray: PropTypes.string
      })
    )
  })
};
